import React from 'react';
import { bool, func, array, object } from 'prop-types';
import { Row, Col } from 'antd';
import { isFunction, reduce, isNil, get, isEmpty, filter, includes } from 'lodash';
import { Form, Field } from 'formik';
import {
    Icon,
    FormikInput,
    FormikSelect,
    SalesChannelSelect,
    ABMGroupsSelect,
    ConditionalRender,
    Text,
    Button
} from '../../common';
import UserDetailForm from './UserDetailForm';
import { validations, thirdPartyCompanies } from '../../../utils/misc';
import classNames from 'classnames';
import '../../../../assets/styles/orders-filter-form.less';

class OrdersFilterContainer extends React.Component {
    fields = (aditionalProps) => {
        return [
            {
                name: 'name',
                label: 'Nombre',
                type: 'input',
                InputComponent: FormikInput,
                format: (value) => value && String(value).toLowerCase()
            },
            {
                name: 'lastName',
                label: 'Apellido',
                type: 'input',
                InputComponent: FormikInput,
                format: (value) => value && String(value).toLowerCase()
            },
            {
                name: 'email',
                label: 'Mail',
                type: 'input',
                InputComponent: FormikInput,
                format: (value) => value && String(value).toLowerCase()
            },
            {
                name: 'rut',
                label: 'RUT',
                validations: [],
                isDocumentId: true,
                maxLength: 12,
                type: 'input',
                InputComponent: FormikInput,
                format: (value) =>
                    value && [validations.document.clean(value), value]
            },
            {
                name: 'company',
                label: 'Empresa',
                type: 'select',
                defaultValue: [],
                options: thirdPartyCompanies(),
                format: ({ value, label }) => {
                    return value;
                },
                InputComponent: FormikSelect
            },
            {
                name: 'groups',
                label: 'Perfil',
                type: 'select',
                multiple: true,
                defaultValue: [],
                filterGroups: get(aditionalProps, 'filterGroups', []),
                format: (value) => value && value.map(({ value }) => String(value)),
                InputComponent: ABMGroupsSelect
            },
            {
                name: 'salesChannels',
                label: 'Sala',
                type: 'select',
                multiple: true,
                InputComponent: SalesChannelSelect,
                defaultValue: [],
                format: (value) => value && value.map(({ value }) => String(value))
            },
            {
                name: 'splitUser',
                label: 'Splitero',
                type: 'select',
                defaultValue: [],
                InputComponent: FormikSelect,
                options: [
                    { value: '0', label: 'No' },
                    { value: '1', label: 'Si' }
                ],
                format: ({ value }) => value
            },
            {
                name: 'statusUser',
                label: 'Estado',
                type: 'select',
                defaultValue: [],
                InputComponent: FormikSelect,
                options: [
                    { value: '0', label: 'Activo' },
                    { value: '1', label: 'Inactivo' }
                ],
                format: ({ value, label }) => {
                    return value;
                }
            }
        ];
    }

    _renderHeader = ({ collapsed, onClick }) => {
        return (
            <a
                href='#'
                onClick={() => onClick(!collapsed)}
                className={classNames('drawer-header', { 'collapsed': collapsed })}
                style={{ paddingTop: '45px' }}
            >
                <Icon name='filters' right={5} style={{ lineHeight: 1.5 }} />
                <ConditionalRender condition={!collapsed}>
                    <Text text='Filtrar por:' />
                </ConditionalRender>
            </a>
        );
    };

    _renderSubmitBtn = ({ loading, dirty, touched }) => {
        return (
            <Row
                style={{
                    justifyContent: 'space-between',
                    marginTop: 24,
                    alignItems: 'flex-end',
                    padding: '0 10px'
                }}
            >
                <Col span={12}>
                    <div>
                        <Button text='Limpiar' link type='reset' />
                    </div>
                </Col>
                <Col span={12}>
                    <div>
                        <Button
                            type='submit'
                            secondary={dirty || touched}
                            loading={loading}
                            text='Aplicar'
                            left='5'
                        />
                    </div>
                </Col>
            </Row>
        );
    };

    _renderForm = ({
        handleSubmit,
        handleReset,
        handleChange,
        values,
        submitCount,
        dirty,
        touched,
        isSubmitting,
        loading,
        setFieldValue
    }) => {
        const { onlyShoppers } = this.props;
        const filterFields = (key) => filter(this.fields(), ({ name }) => !includes([key], name));

        const fields = filterFields(onlyShoppers ? 'groups' : 'splitUser');

        return (
            <div style={{ width: '100%' }}>
                <Form
                    className='filter-form'
                    onSubmit={handleSubmit}
                    onReset={handleReset}
                >
                    {fields.map(
                        (
                            { label, name, InputComponent, onChange, ...props },
                            index
                        ) => (
                            <Field
                                style={{ marginTop: 12 }}
                                name={name}
                                key={`filter-form-${index}`}
                                label={label}
                                {...props}
                                component={InputComponent}
                                setFieldValue={setFieldValue}
                            />
                        )
                    )}
                    {this._renderSubmitBtn({ loading, dirty, touched })}
                </Form>
            </div>
        );
    };

    handleSubmit = async (values) => {
        const { onSubmit } = this.props;
        const filters = Object.keys(values).map((field) => {
                const { format } = this.fields().find(({ name }) => field === name) || {};
                const value = {
                    field,
                    type: typeof get(values, `${field}.value`, get(values, field)),
                    value: isFunction(format) ? format(values[field]) : values[field]
                };
                return value;
            })
            .filter(({ value }) => !isNil(value) && !isEmpty(value));

        onSubmit({ filters });
    };

    onReset = async (values) => {
        const { onReset } = this.props;
        onReset({ filters: {} });
    };

    render () {
        const { collapsed, onClick } = this.props;
        const initialValues = reduce(
            this.fields,
            (acc, { name, defaultValue = '' }) =>
                Object.assign({}, acc, { [name]: defaultValue }),
            {}
        );
        return (
            <div
                className='flex-start'
                style={{
                    width: '100%',
                    padding: 15,
                    paddingTop: 0,
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {this._renderHeader({ collapsed, onClick })}
                {!collapsed && (
                    <UserDetailForm
                        initialValues={initialValues}
                        onSubmit={this.handleSubmit}
                        onReset={this.onReset}
                        FormComponent={(props) => this._renderForm(props)}
                    />
                )}
            </div>
        );
    }
}

OrdersFilterContainer.propTypes = {
    collapsed: bool,
    initialValues: object,
    onClick: func,
    onSubmit: func,
    onReset: func,
    onlyShoppers: bool,
    abmOperUserAllowed: array
};

OrdersFilterContainer.defaultProps = {
    initialValues: {}
};

export default OrdersFilterContainer;
